import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import EyeIcon from "../../../assets/svg/eye.svg";
import ClosedEyeIcon from "../../../assets/svg/eyeOff.svg";
import { getString } from "../../utilities";

export default function TextViewHook({
  name,
  type = "text",
  shouldPasswordToggle = false,
  defaultValue,
  errors,
  placeholder,
  label,
  className = "",
  isReadOnly = false,
  isDisabled = false,
  children = null,
  onChange,
  rules,
  dataTestId,
  autoComplete,
}) {
  const [showLabel, setShowLabel] = useState(false);
  const [tagType, setTagType] = useState(type);
  const { register } = useFormContext();

  const passwordType = "password";
  const isPasswordType = type === passwordType;
  let shouldAutoComplete = autoComplete;

  if (!shouldAutoComplete && isPasswordType) {
    shouldAutoComplete = "off";
  }

  const formFieldClass = `form-field ${className}`;

  useEffect(() => {
    if (defaultValue && defaultValue.length > 0) {
      setShowLabel(true);
    }
  }, []);

  const handleInputChange = (e) => {
    if (onChange) {
      onChange(e);
    }
    setShowLabel(e.target.value.length > 0);
  };

  const renderLabel = () => {
    if (label && label.length > 0) {
      const labelClass = showLabel ? "active" : "";

      return (
        <label htmlFor={name} className={labelClass}>
          {label}
        </label>
      );
    }

    return null;
  };

  const renderTag = () => {
    const hold = placeholder || label || "";

    if (type === "textarea") {
      return (
        <textarea
          id={name}
          placeholder={hold}
          defaultValue={defaultValue || ""}
          {...register(name, { ...rules, onChange: handleInputChange })}
          readOnly={isReadOnly}
          disabled={isDisabled}
          data-testid={dataTestId}
        />
      );
    }

    const autoCompleteProp = shouldAutoComplete ? { autoComplete: shouldAutoComplete } : {};

    return (
      <input
        id={name}
        type={tagType}
        placeholder={hold}
        defaultValue={defaultValue || ""}
        {...register(name, { ...rules, onChange: handleInputChange })}
        readOnly={isReadOnly}
        disabled={isDisabled}
        data-testid={dataTestId}
        {...autoCompleteProp}
      />
    );
  };

  const renderPasswordToggle = () => {
    if (isPasswordType && shouldPasswordToggle) {
      const isTagPassword = tagType === passwordType;
      const renderEyeIcon = () => {
        if (isTagPassword) {
          return <EyeIcon />;
        }

        return <ClosedEyeIcon />;
      };

      return (
        <a
          role="button"
          title={getString("password.toggle")}
          className="form-field-password-reveal"
          onClick={() => {
            if (isTagPassword) {
              setTagType("text");
            } else {
              setTagType(passwordType);
            }

            return false;
          }}
        >
          {renderEyeIcon()}
        </a>
      );
    }

    return null;
  };

  return (
    <div className={formFieldClass}>
      {children}
      <div className={`form-field-container${isPasswordType && shouldPasswordToggle ? " password" : ""}`}>
        {renderLabel()}
        {renderTag()}
        {renderPasswordToggle()}
        {errors[name] && <div className="validation-error">{errors[name].message}</div>}
      </div>
    </div>
  );
}
